export default __webpack_public_path__ + "de52b1be29c4e8d41ad277f91ebdb31c.svg";